import BunkeyAPI from '../api/BunkeyAPI'
import {
  ASSET_SHARED_GET_DATA,
  ASSET_SHARED_GET_DATA_SUCCESS,
  ASSET_SHARED_GET_DATA_FAILURE,
  SHARE_ASSET,
  SHARE_ASSET_SUCCESS,
  SHARE_ASSET_FAILURE,
  ASSET_SHARED_ACTIVEVIEW,
  ASSET_SHARED_EDIT,
  ASSET_SHARED_EDIT_SUCCESS,
  ASSET_SHARED_EDIT_FAILURE,
  ASSET_SHARED_SET_SELECT,
  ASSET_SHARED_UNSET_SELECT,
  ASSET_SHARED_DELETE,
  ASSET_SHARED_DELETE_SUCCESS,
  ASSET_SHARED_DELETE_FAILURE,
  ASSET_SHARED_EDIT_SELECT,
  ASSET_SHARED_EDIT_UNSET_SELECT,
  ASSET_SHARED_EXPAND_SELECT,
  ASSET_SHARED_EXPAND_UNSET_SELECT,
  ASSET_SHARED_SHARE_SELECT,
  ASSET_SHARED_SHARE_UNSET_SELECT,
  ASSET_SHARED_MOVE,
  ASSET_SHARED_MOVE_SUCCESS,
  ASSET_SHARED_MOVE_FAILURE,
  ASSET_SHARED_CHECK_SELECT,
  ASSET_SHARED_UNCHECK_SELECT,
  MULTIPLE_SHARED_OPTIONS_ACTIVATE,
  MULTIPLE_SHARED_OPTIONS_DEACTIVATE,
  MULTIPLE_SHARED_OPTIONS_DONE,
  ASSETS_SHARED_MULTI_DELETE,
  ASSETS_SHARED_MULTI_DELETE_SUCCESS,
  ASSETS_SHARED_MULTI_DELETE_FAILURE,
  ASSETS_SHARED_MULTI_MOVE,
  ASSETS_SHARED_MULTI_MOVE_SUCCESS,
  ASSETS_SHARED_MULTI_MOVE_FAILURE,
} from '../constants/assets-share-types'
import { sendNotification, permissionsDefault, validateImageSpecialExtensions } from '../utils';
import store from '../store'

export const getShared = (workclient, folderselect, page = 1, isFetching = true, data = []) => {
  const user = store.getState().authUser.user
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_GET_DATA,
      payload: {
        isFetching,
        data,
      }
    })
    BunkeyAPI({
      url: `/users/me/clients/${workclient}/shared`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: ASSET_SHARED_GET_DATA_SUCCESS,
        payload: {
          user,
          page,
          folderselect,
          data: resp.data
            .map(r => {
              return {
                _id: r._id,
                type: validateImageSpecialExtensions(r.originalURL) ? 'document' : r.type,
                name: r.name,
                lowQualityURL: r.lowQualityURL,
                mediaQualityURL: r.mediaQualityURL,
                originalURL: r.originalURL,
                metadata: r.metadata,
                rightsState: r.rightsState,
                dueDate: r.dueDate,
                isContent: r.isContent,
                parents: r.parents,
                createdAt: r.createdAt,
                user: r.user && r.username ? { id: r.user, name: r.username } : { id: '', name: '' },
                group: r.group,
                objectGroups: r.objectGroup,
                fileSizeFormat: r.fileSizeFormat,
                tagProtocol: r.tagProtocol,
                documentPages: r.documentPages,
                matrix: permissionsDefault().map(def => {
                  const exists = r.group.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
                  return {
                    action: def.action,
                    enabled: exists ? true : false
                  }
                }),
                uuid: r.uuid,
              }
            }),
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_SHARED_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}

export const sendShareAsset = (workclient, user, itemToShare, message, password, emails, intl, expiresIn) => {
  return dispatch => {
    dispatch({ type: SHARE_ASSET })

    const sendEmails = emails.join(';')
    BunkeyAPI({
      url: `/shared`,
      method: 'POST',
      data:
      {
        email: sendEmails,
        object: itemToShare._id,
        user: user,
        client: workclient,
        message: message,
        password: password,
        expiresIn: expiresIn ? expiresIn : 10
      }
    }).then(resp => {
      dispatch({
        type: SHARE_ASSET_SUCCESS,
        payload: {
          data: itemToShare,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_shared' }))
      // }
    }).catch(err => {
      dispatch({
        type: SHARE_ASSET_FAILURE,
        payload: err
      })
      sendNotification('error', intl, intl.formatMessage({ id: 'asset_could_not_share' }))
    })
  }
}
export const sendShareAssets = (workclient, user, items, message, password, emails, intl, expiresIn) => {
  return dispatch => {
    dispatch({ type: SHARE_ASSET })

    const sendEmails = emails.join(';')
    BunkeyAPI({
      url: `/shared`,
      method: 'POST',
      data:
      {
        email: sendEmails,
        object: items,
        user: user,
        client: workclient,
        message: message,
        password: password,
        expiresIn: expiresIn,
      }
    }).then(resp => {
      dispatch({
        type: SHARE_ASSET_SUCCESS,
        payload: {
          // data: itemToShare,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_shared' }))
      // }
    }).catch(err => {
      dispatch({
        type: SHARE_ASSET_FAILURE,
        payload: err
      })
      sendNotification('error', intl, intl.formatMessage({ id: 'asset_could_not_share' }))
    })
  }
}
export const sendShareAssetsUpload = (workclient, user, items, message, password, emails, intl, expiresIn) => {
  return dispatch => {
    dispatch({ type: SHARE_ASSET })

    const sendEmails = emails.join(';')
    BunkeyAPI({
      url: `/shared`,
      method: 'POST',
      data:
      {
        email: sendEmails,
        object: items,
        user: user,
        client: workclient,
        message: message,
        password: password,
        expiresIn: expiresIn,
      }
    }).then(resp => {
      dispatch({
        type: SHARE_ASSET_SUCCESS,
        payload: {
          // data: itemToShare,
          headers: resp.headers
        }
      })
      // if (multiple) {
      // sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_shared' }))
      // }
    }).catch(err => {
      dispatch({
        type: SHARE_ASSET_FAILURE,
        payload: err
      })
      // sendNotification('error', intl, intl.formatMessage({ id: 'asset_could_not_share' }))
    })
  }
}
export const setSelectSharedAsset = (item, indice, from, verticalCount, horizontalCount) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_SET_SELECT,
      payload: {
        data: item,
        indice,
        from,
        verticalCount,
        horizontalCount
      }
    })
  }
}

export const unsetSelectSharedAsset = () => {
  return dispatch => {
    dispatch({ type: ASSET_SHARED_UNSET_SELECT })
  }
}

export const setSharedActiveView = view => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    })
  }
}

export const setEditSharedAsset = (workclient, asset) => {
  return dispatch => {
    dispatch({ type: ASSET_SHARED_EDIT })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags,
          createdDate: asset.metadata.createDate,
          dueDate: asset.metadata.dueDate
        }
      }
    }).then(resp => {
      dispatch({
        type: ASSET_SHARED_EDIT_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_SHARED_EDIT_FAILURE,
        payload: err
      })
    })
  }
}

export const setExpandSharedAsset = (asset) => {
}

export const deleteSharedAsset = (workclient, id, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_SHARED_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: 'DELETE',
    }).then(resp => {
      dispatch({
        type: ASSET_SHARED_DELETE_SUCCESS,
        payload: {
          workclient,
          id
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_deleted' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_SHARED_DELETE_FAILURE,
        payload: {
          workclient,
          id,
          error: err
        }
      })
      // if (multiple) {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_deleting_asset' }))
      // }
    })
  }
}

export const setSelectEditSharedAsset = (asset, editAssetTab) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab
      }
    })
  }
}

export const unsetSelectEditSharedAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_EDIT_UNSET_SELECT
    })
  }
}

export const setSelectExpandSharedAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_EXPAND_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectExpandSharedAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_EXPAND_UNSET_SELECT
    })
  }
}

export const setSelectShareSharedAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_SHARE_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectShareSharedAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_SHARE_UNSET_SELECT
    })
  }
}

export const moveSharedAsset = (workclient, asset, folder, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_SHARED_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        action: 'move',
        folder: folder
      }
    }).then(resp => {
      dispatch({
        type: ASSET_SHARED_MOVE_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_SHARED_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'the_asset' })} ${asset.name} ${intl.formatMessage({ id: 'could_not_move' })}`)
    })
  }
}

export const setCheckSharedAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_CHECK_SELECT,
      payload: asset
    })
  }
}
export const unsetCheckSharedAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_SHARED_UNCHECK_SELECT,
      payload: asset
    })
  }
}

export const activateSharedOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SHARED_OPTIONS_ACTIVATE
    })
  }
}

export const deactivateSharedOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SHARED_OPTIONS_DEACTIVATE
    })
  }
}

export const isDoneMultipeSharedOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SHARED_OPTIONS_DONE
    })
  }
}
export const multiDeleteSharedAsset = (workclient, intl, items) => {
  return (dispatch) => {
    dispatch({ type: ASSETS_SHARED_MULTI_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: 'PUT',
      data: {
        data: items
      }
    })
      .then((resp) => {
        dispatch({
          type: ASSETS_SHARED_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items,
          },
        })
        sendNotification(
          'success',
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        )
      })
      .catch((err) => {
        dispatch({
          type: ASSETS_SHARED_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err,
          },
        })
        // if (multiple) {
        sendNotification(
          'error',
          intl,
          `${intl.formatMessage({ id: 'assets_has_not_been_deleted' })}`
        )
        // }
      })
  }
}
export const moveMultiselectSharedAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_SHARED_MULTI_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: 'PUT',
      data: {
        data: ids
      }
    }).then(resp => {
      dispatch({
        type: ASSETS_SHARED_MULTI_MOVE_SUCCESS,
        payload: {
          ids: ids,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSETS_SHARED_MULTI_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'assets_could_not_moved' })}`)
    })
  }
}
